export const FILE_MAX_SIZE = 2097152
export const IMAGE_CHAT_MAX_SIZE = 10000000
